import React from 'react';
import PropTypes from 'prop-types';

import getDetails from '../../../../../modules/getOrderStatusDetails';
import {
  BookingCode,
  IconBack,
  StatusText,
  useHeaderStyles,
} from './style';
import { historyPropTypes } from '../../../../../types';


const Header = ({
  history, bookingCode, status,
}) => {
  const classes = useHeaderStyles();
  const details = getDetails(status);
  const onBack = () => {
    history.push('/orders');
  };

  return (
    <div className={classes.root}>
      <IconBack onClick={onBack} />
      <BookingCode>{`Order #${bookingCode}`}</BookingCode>
      <StatusText color={details.color}>{details.text}</StatusText>
    </div>
  );
};

Header.propTypes = {
  bookingCode: PropTypes.string,
  history    : historyPropTypes.isRequired,
  status     : PropTypes.string,
};

Header.defaultProps = {
  bookingCode: '',
  status     : '',
};

export default Header;
